<template>
  <span class="energy-efficiency-class" :title="text">
    {{text}}
  </span>
</template>

<script>
import camelCase from 'lodash/camelCase';

export default {
  name: 'energy-efficiency-class',
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  computed: {
    text() {
      if (!this.value) return undefined;
      return this.$t(`energyEfficiencyClasses.${camelCase(this.value)}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// EnergyEfficiencyClass.vue?37eeb693